import React, { useState } from 'react';
import { useLang } from '../../core/lang';
import LangKeys from '../../core/locales/keys';
import { X, Check, MapPin } from 'lucide-react';

const PartyAddressModal = ({ isOpen, onClose, initialAddress, onSave }) => {
  const { t } = useLang();
  const [address, setAddress] = useState(initialAddress || { flatNo: '', area: '', city: '', state: '', pincode: '' });

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
           <h3 style={styles.title}>{t(LangKeys.add_bill_party_address)}</h3>
           <button style={styles.closeBtn} onClick={onClose}><X size={20} /></button>
        </div>
        
        <div style={styles.content}>
           <div style={styles.inputField}>
              <label style={styles.label}>{t(LangKeys.address_flat_no || 'Flat / House No.')}</label>
              <input 
                style={styles.input} 
                value={address.flatNo} 
                onChange={(e) => setAddress({...address, flatNo: e.target.value})} 
                placeholder="e.g. 101, Galaxy Apt"
              />
           </div>
           <div style={styles.inputField}>
              <label style={styles.label}>{t(LangKeys.address_area || 'Area / Locality')}</label>
              <input 
                style={styles.input} 
                value={address.area} 
                onChange={(e) => setAddress({...address, area: e.target.value})} 
                placeholder="e.g. MG Road, West End"
              />
           </div>
           <div style={styles.row}>
              <div style={styles.inputField}>
                 <label style={styles.label}>{t(LangKeys.address_city || 'City')}</label>
                 <input 
                   style={styles.input} 
                   value={address.city} 
                   onChange={(e) => setAddress({...address, city: e.target.value})} 
                   placeholder="City"
                 />
              </div>
              <div style={styles.inputField}>
                 <label style={styles.label}>{t(LangKeys.address_pincode || 'Pincode')}</label>
                 <input 
                   style={styles.input} 
                   value={address.pincode} 
                   onChange={(e) => setAddress({...address, pincode: e.target.value})} 
                   placeholder="123456"
                 />
              </div>
           </div>
           <div style={styles.inputField}>
              <label style={styles.label}>{t(LangKeys.address_state || 'State')}</label>
              <input 
                style={styles.input} 
                value={address.state} 
                onChange={(e) => setAddress({...address, state: e.target.value})} 
                placeholder="State"
              />
           </div>
        </div>

        <div style={styles.footer}>
           <button style={styles.saveBtn} onClick={() => onSave(address)}>
              <Check size={18} /> <span>SAVE ADDRESS</span>
           </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000 },
  modal: { width: '100%', maxWidth: '440px', background: 'white', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' },
  header: { padding: '20px 24px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontSize: '18px', fontWeight: '800', color: '#0F172A', margin: 0 },
  closeBtn: { border: 'none', background: 'transparent', cursor: 'pointer', color: '#94A3B8' },
  content: { padding: '24px', display: 'flex', flexDirection: 'column', gap: '16px' },
  inputField: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '11px', fontWeight: '800', color: '#94A3B8', textTransform: 'uppercase' },
  input: { height: '48px', padding: '0 16px', borderRadius: '12px', border: '1px solid #E2E8F0', background: '#F8FAFC', fontSize: '15px', fontWeight: '600', outline: 'none' },
  row: { display: 'flex', gap: '16px' },
  footer: { padding: '16px 24px', background: '#F8FAFC', borderTop: '1px solid #F1F5F9' },
  saveBtn: { width: '100%', height: '48px', borderRadius: '12px', border: 'none', background: '#1D4ED8', color: 'white', fontWeight: '800', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', cursor: 'pointer' }
};

export default PartyAddressModal;
